import ClearanceCertificatePayment from './ClearanceCertificatePayment'

export default ClearanceCertificatePayment
